import * as Component from 'components';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as PlaylistComponent from '../components';
import PlaylistContentList from '../components/PlaylistContentList';
import { playlistApiService } from '../services/playlistApiService';

const PlaylistEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [playlistType, setPlaylistType] = useState<string>('');

  useEffect(() => {
    setIsLoading(true);
    playlistApiService.fetchById(Number(id)).then(data => {
      setPlaylistType(data.type);
      setIsLoading(false);
    });
  }, [id]);

  const playlistTabItem =
    playlistType === 'dynamic'
      ? [
          {
            key: 'playlist-rule',
            title: 'Playlist Rule',
            component: <PlaylistComponent.PlaylistRule />,
          },
          {
            key: 'videos',
            title: 'Videos',
            component: <PlaylistComponent.PlaylistVideos id={id as string} />,
          },
        ]
      : [
          {
            key: 'videos',
            title: 'Videos',
            component: <PlaylistContentList />,
          },
        ];

  const playlistComponents = [
    {
      key: 'detail',
      title: 'Detail',
      component: <PlaylistComponent.PlaylistDetail />,
    },
    ...playlistTabItem,
  ];

  return (
    <Component.BasePageComponent>
      {isLoading ? (
        <Component.LoadingSpinnerComponent />
      ) : (
        <Component.TapComponent components={playlistComponents} />
      )}
    </Component.BasePageComponent>
  );
};

export default PlaylistEdit;
